import React from 'react';
import { Link } from 'react-router-dom';

const AcknowledgementPage = () => {
  return (
    <>
      {/* Page Header */}
      <section className="py-5 bg-primary text-white text-center">
        <div className="container py-2">
          <h1>Acknowledgement of Country</h1>
          <p className="mx-auto" style={{ maxWidth: '700px' }}>
            We acknowledge the Traditional Custodians of the lands on which we work and live.
          </p>
        </div>
      </section>
      
      {/* Acknowledgement Content */}
      <section className="py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="mb-5">
                <p className="lead">
                  Dozzy.au acknowledges the Traditional Custodians of the lands throughout Australia on which our company operates, 
                  and pays respect to their Elders past, present and emerging.
                </p>
                
                <p>
                  We acknowledge the deep connection to Country that Aboriginal and Torres Strait Islander peoples have, 
                  and we recognize that this connection has been sustained for more than 65,000 years.
                </p>
                
                <p>
                  We acknowledge that sovereignty was never ceded, and we recognize the ongoing role of Aboriginal and Torres Strait Islander 
                  peoples as the First Peoples of this nation.
                </p>
                
                <p>
                  As an organization that works with families and children across Australia, we are committed to listening, 
                  learning, and working respectfully with Aboriginal and Torres Strait Islander families and communities.
                </p>
                
                <p>
                  We recognize the importance of cultural practices and traditions in raising children, and we respect the diverse 
                  parenting approaches of Aboriginal and Torres Strait Islander peoples. We acknowledge that traditional child-rearing 
                  practices have supported healthy development and strong communities for thousands of generations.
                </p>
                
                <p>
                  We are committed to creating an inclusive environment that respects and values the cultural heritage, 
                  beliefs, and practices of Aboriginal and Torres Strait Islander peoples, and we strive to incorporate 
                  cultural awareness and sensitivity in all aspects of our work.
                </p>
              </div>
              
              <div className="mb-5">
                <h3>Our Commitment</h3>
                <p>
                  At Dozzy.au, we are committed to:
                </p>
                <ul>
                  <li>Respecting and acknowledging the cultural heritage and practices of Aboriginal and Torres Strait Islander peoples</li>
                  <li>Ensuring our services are culturally appropriate and accessible to Aboriginal and Torres Strait Islander families</li>
                  <li>Continuing to learn about and understand the diverse cultures, histories, and experiences of Aboriginal and Torres Strait Islander peoples</li>
                  <li>Supporting initiatives that promote reconciliation and close the gap in health and wellbeing outcomes</li>
                  <li>Creating opportunities for Aboriginal and Torres Strait Islander peoples within our organization</li>
                </ul>
              </div>
              
              <div className="mb-5">
                <h3>Resources</h3>
                <p>
                  We encourage our team members and users to learn more about Aboriginal and Torres Strait Islander cultures, 
                  histories, and contributions through the following resources:
                </p>
                <ul>
                  <li><a href="https://aiatsis.gov.au/" target="_blank" rel="noopener noreferrer">Australian Institute of Aboriginal and Torres Strait Islander Studies</a></li>
                  <li><a href="https://www.reconciliation.org.au/" target="_blank" rel="noopener noreferrer">Reconciliation Australia</a></li>
                  <li><a href="https://www.commonground.org.au/" target="_blank" rel="noopener noreferrer">Common Ground</a></li>
                  <li><a href="https://www.snaicc.org.au/" target="_blank" rel="noopener noreferrer">SNAICC – National Voice for our Children</a></li>
                </ul>
              </div>
              
              <div className="text-center mt-5">
                <Link to="/" className="btn btn-outline-red">Return to Home</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AcknowledgementPage;
